export const FORM_ELEMENT_TYPES = {
  GROUP: 'group',
  TEXT: 'text',
  CHECKBOX: 'checkbox',
  NUMBER: 'number',
  DATE: 'date',
  DROPDOWN: 'select',
  MULTIPLE: 'selectMultiple',
  PHONE_NUMBER: "phoneNumber",
  ICON_BUTTON: "iconButton",
  AUTOCOMPLETE: "autoComplete"
};

export const VALID_FORM_ELEMENT_TYPES = [
  FORM_ELEMENT_TYPES.GROUP,
  FORM_ELEMENT_TYPES.TEXT,
  FORM_ELEMENT_TYPES.CHECKBOX,
  FORM_ELEMENT_TYPES.NUMBER,
  FORM_ELEMENT_TYPES.DATE,
  FORM_ELEMENT_TYPES.DROPDOWN,
  FORM_ELEMENT_TYPES.MULTIPLE,
  FORM_ELEMENT_TYPES.PHONE_NUMBER,
  FORM_ELEMENT_TYPES.ICON_BUTTON,
  FORM_ELEMENT_TYPES.AUTOCOMPLETE
];
